var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params)?_c('div',[(_vm.params)?_c('span',[_vm._v(" "+_vm._s(_vm._f("dateFormat")(_vm.params))+" ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }